'use client';
import React from 'react';
import { styled } from '../stitches.config.js';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from '@radix-ui/react-icons';

const StyledCheckbox = styled(CheckboxPrimitive.Root, {
    all: 'unset',
    boxSizing: 'border-box',
    userSelect: 'none',
    '&::before': {
        boxSizing: 'border-box',
    },
    '&::after': {
        boxSizing: 'border-box',
    },
    alignItems: 'center',
    appearance: 'none',
    display: 'inline-flex',
    justifyContent: 'center',
    lineHeight: '1',
    margin: '0',
    outline: 'none',
    padding: '0',
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    color: '$hiContrast',
    boxShadow: 'inset 0 0 0 1px $colors$gray7',
    overflow: 'hidden',
    '@hover': {
        '&:hover': {
            boxShadow: 'inset 0 0 0 1px $colors$gray8',
        },
    },
    '&:focus': {
        outline: 'none',
        borderColor: '$error7',
        boxShadow: 'inset 0 0 0 1px $colors$info9, 0 0 0 1px $colors$info9',
    },
    variants: {
        size: {
            '1': {
                width: '$3',
                height: '$3',
                borderRadius: '$1',
            },
            '2': {
                width: '$5',
                height: '$5',
                borderRadius: '$2',
            },
        },
    },
    defaultVariants: {
        size: '1',
    },
});
const StyledIndicator = styled(CheckboxPrimitive.Indicator, {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
});
const Checkbox = React.forwardRef((props, forwardedRef) => (React.createElement(StyledCheckbox, Object.assign({}, props, { ref: forwardedRef }),
    React.createElement(StyledIndicator, null,
        React.createElement(CheckIcon, null)))));

export { Checkbox };
